import { ofOrderDetailSummary } from './OrderDetailSummary'
import { ofOrderDetailDiscount } from './OrderDetailDiscount'
import { ofOrderDetailPayment } from './OrderDetailPayment'
import { ofOrderDetailDelivery } from './OrderDetailDelivery'
import { ofOrderDetailProduct } from './OrderDetailProduct'
import { ofOrderDetailReservation } from './OrderDetailReservation'
import { ofOrderDetailPoint } from './OrderDetailPoint'

const OrderDetail = class {
  constructor({ summary, products, payment, delivery, discounts, orderReservation, point }) {
    this.summary = ofOrderDetailSummary(summary)
    this.products = Array.isArray(products) ? products.map((e) => ofOrderDetailProduct(e)) : []
    this.payment = ofOrderDetailPayment({ ...payment, ...summary })
    this.delivery = ofOrderDetailDelivery(delivery)
    this.discounts = Array.isArray(discounts) ? discounts.map((e) => ofOrderDetailDiscount(e)) : []
    this.orderReservation = ofOrderDetailReservation(orderReservation)
    this.point = ofOrderDetailPoint(point || {})
  }

  get discountAmount() {
    return this.discounts.reduce((acc, e) => acc + e.amount, 0)
  }

  canDelete({ isSignedUser = false }) {
    const isSign = !!isSignedUser
    const notInProgress = this.summary.isNotInProgress()
    const notDeleted = !this.summary.deleted

    return isSign && notDeleted && notInProgress
  }
}

export default null

export const ofOrderDetail = (params = {}) => new OrderDetail(params)
